import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, watchEffect } from "../../../adapter-vue";
import TUIChatEngine, {
  TUITranslateService,
  TUIUserService,
  TUIConversationService,
  TUIFriendService,
  TUIStore,
  StoreName,
} from "@tencentcloud/chat-uikit-engine";
import { TUIGlobal } from "@tencentcloud/universal-api";
import Avatar from "../../common/Avatar/index.vue";
import { IUserProfile } from "../../../interface";
import { isUniFrameWork } from "../../../utils/env";


export default /*#__PURE__*/_defineComponent({
  __name: 'manage-profile',
  props: {
  userInfo: {
    type: Object,
    default: () => ({}),
  },
},
  emits: [
  "handleSwitchConversation",
  "close",
  "openConversation",
],
  setup(__props, { emit: emits }) {

const props = __props



const isFriendShip = ref(false);
const userInfoManager = ref<IUserProfile>({});
const title = ref("");
const depart = ref("");
watchEffect(() => {
  userInfoManager.value = props.userInfo;
});


watch(
  () => props.userInfo,
  async (newVal: any, oldVal: any) => {
    if (newVal === oldVal) return;
    const res = await TUIUserService.getUserProfile({
      userIDList: [props.userInfo.userID],
    });
    userInfoManager.value = res?.data[0];
    const profileCustomField = res?.data[0].profileCustomField;
    profileCustomField.forEach((item: any) => {
      if (item.key === "Tag_Profile_Custom_title") {
        title.value = item.value;
      }
      if (item.key === "Tag_Profile_Custom_Depart") {
        depart.value = item.value;
      }
    });
    checkFriend();
  },
  {
    deep: true,
    immediate: true,
  }
);

const enter = async (ID: any, type: string) => {
  const name = `${type}${ID}`;
  TUIConversationService.getConversationProfile(name)
    .then((res: any) => {
      TUIConversationService.switchConversation(
        res.data.conversation.conversationID
      ).then(() => {
        TUIStore.update(StoreName.GRP, "isShowManageComponent", false);
        if (isUniFrameWork) {
          TUIGlobal?.navigateBack();
        }
      });
    })
    .catch((err: any) => {
      console.warn("获取会话资料失败", err.code, err.msg);
    });
};
const checkFriend = async () => {
  if (!(userInfoManager.value as any).userID) return;
  TUIFriendService.checkFriend({
    userIDList: [userInfoManager.value.userID],
    type: TUIChatEngine.TYPES.SNS_CHECK_TYPE_BOTH,
  }).then((res: any) => {
    const relation = res?.data?.successUserIDList?.[0]?.relation;
    isFriendShip.value = relation === TUIChatEngine.TYPES.SNS_TYPE_BOTH_WAY;
  });
};

const showEnter = () => {
  return isFriendShip.value || !TUIStore.getData(StoreName.APP, "isOfficial");
};

const close = (tabName: string) => {
  emits("close", tabName);
};

return { __sfc: true,props, isFriendShip, userInfoManager, title, depart, emits, enter, checkFriend, showEnter, close, TUITranslateService, Avatar, isUniFrameWork }
}

})